export const TAG_NAME = 'portal/tracking/landing_page';
export const PREFERENCE = {
    CASINO: 'casino',
    SPORTS: 'sports'
};
export const DEFAULT_FORM_DATA = { preference: PREFERENCE.CASINO };
